var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metric-cards-row"},[_vm._l((_vm.cards),function(card,index){return [_c('div',{key:index,staticClass:"metric-card"},[_c('strong',{class:{ 'is-loading': card.value == null }},[_vm._v(_vm._s(card.value))]),_c('span',[_vm._v(_vm._s(card.text))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }